var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.1,22.55v-4.1H28.7l-8.2-8.2,2.05-4.1L36.9,20.5,22.55,34.85l-2.05-4.1,8.2-8.2Z","transform":"translate(-4.1 -6.15)"}));
}

ArrowR.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32.8 28.7"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
